<template>
  <div v-if="customFields.length > 0">
    <div class="d-flex align-items-center pointer" @click="isExpanded = !isExpanded">
      <i class="caret-down-icon collapse-icon" v-if="isExpanded"></i>
      <i class="caret-right-icon collapse-icon" v-else></i>
      <span class="ml-2 text-medium" :class="{ bold: isExpanded }">Hidden fields</span>
    </div>
    <b-collapse class="expanded-section mt-1" v-model="isExpanded">
      <div class="field d-flex align-items-center" v-for="field in customFields" :key="field.id">
        {{ field.name }}:
        <div class="text-secondary ml-2">
          <computed-field-value
            :value="getFormattedValue(field)"
            :error="field.error"
            v-if="field.isComputed"
          />
          <template v-else>
            {{ getFormattedValue(field) }}
          </template>
        </div>
      </div>
      <div class="mt-2">
        <i class="text-secondary">These fields are not available in the {{ spaceName }}</i>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import ComputedFieldValue from '@/components/initiative/ComputedFieldValue.vue'
import { CUSTOM_FIELD_TYPE } from '@/constants/customFields'
import { formatDate } from '@/utils/formatDate'
import getTeamSpaceName from '@/utils/getTeamSpaceName'
import { BCollapse } from 'bootstrap-vue'
import * as R from 'ramda'

/**
 * This shows the list of hidden fields.
 * Hidden fields are the ones that have value set for Initiative and the field is not available for use in Team/Project.
 */
export default {
  name: 'HiddenCustomFieldsView',
  components: { ComputedFieldValue, BCollapse },
  props: ['customFields', 'initiative'],
  computed: {},
  data() {
    return {
      isExpanded: false,
      spaceName: this.initiative.projectId
        ? 'Project'
        : getTeamSpaceName(this.$store.getters.teamById(this.initiative.teamId))
    }
  },
  methods: {
    getFormattedValue(field) {
      switch (field.type) {
        case CUSTOM_FIELD_TYPE.DATE:
          return formatDate(field.value)
        case CUSTOM_FIELD_TYPE.USER: {
          const user = this.$store.getters.userById(field.value) || {}
          return user.displayName
        }
        case CUSTOM_FIELD_TYPE.DROPDOWN: {
          const dropdownOption = field.dropdownOptions.find(R.propEq('id', field.value)) || {}
          return dropdownOption.name
        }
        default:
          return field.value
      }
    }
  }
}
</script>

<style scoped lang="scss">
.collapse-icon {
  transition: all ease-in 100ms;
}
.field {
  padding: 2px 0;
}
.expanded-section {
  padding-left: 18px;
}
</style>
